import { UnknownObject } from '../../../../react-app-env';

export interface SpecialityPathway {
  pathway: UnknownObject;
  notes: string;
}

export interface MultipleSpecialityPathway {
  [key: string]: SpecialityPathway;
}

export interface ValidationErrors {
  incomplete: string | boolean;
  characterLimitExceeded: string | boolean;
}

export const validationErrors: ValidationErrors = {
  incomplete: 'Please complete all required * fields',
  characterLimitExceeded: 'One or more fields exceed the character limit',
};
export const specialityPathwayReducer = (
  state: MultipleSpecialityPathway,
  action: { type: string; specialityCategoryId: string; id: string; value: string }
): MultipleSpecialityPathway => {
  const currentPathway = state[action.specialityCategoryId] || { pathway: {}, notes: '' };

  switch (action.type) {
    case 'PATHWAY':
      return {
        ...state,
        [action.specialityCategoryId]: {
          ...currentPathway,
          pathway: {
            ...currentPathway.pathway,
            [action.id]: action.value,
          },
        },
      };

    case 'NOTES':
      return {
        ...state,
        [action.specialityCategoryId]: {
          ...currentPathway,
          notes: action.value,
        },
      };

    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};
